import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import {
  Button,
  Card,
  Table,
  TableBody,
  TableCell,
  TableRow,
  CircularProgress,
  Chip,
  Box,
  Tooltip,
  CardContent,
  Grid,
  Container,
} from "@mui/material";

import LoadingButton from "@mui/lab/LoadingButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  CustomTableContainer,
  CustomTableHead,
  TableHeaderFont,
} from "../../styles/tableContent.style";
import moment from "moment";
import {
  getVendorRequestsThunk,
  getAdminVendorRequestsThunk,
  uploadVendorDocThunk,
} from "./redux/documentRequestsSlice";
import {
  submitVendorEdit,
  getVendorDetails,
  vendorRegistrationUpdateDocuments,
  clearVendorDetails,
} from "../vendorRegistration/redux/vendorRegistrationSlice";
import LocalStorage, { SESSION_KEY } from "../../utilities/localStorage";
import {
  StyledCard,
  StyledOutlineButton,
} from "../vendorRegistration/components/StepMain";
import { VendorCardTitle } from "../vendorRegistration/components/steps/vendorReg";
import { message } from "antd";
import { useFeature } from "../../common/featureFlags/FeatureProvider";
import { ROLES, ADMIN_ROLES } from "../../utilities/roles";
import { styled as materialStyles } from "@mui/material/styles";
import styled from "styled-components";
import { FileDownload } from "@mui/icons-material";
import info from "../../assets/icon.png";
import VRF_vishakha from "../../assets/F-PUR-03-VRF-Vishakha.DOCX";

const Input = materialStyles("input")({
  display: "none",
});

const DocumentLabels = styled.div`
  color: #1e1e1e;
  font-size: 14px;
  font-family: var(--font-family-reg);
  font-weight: 500;
  margin-top: 10px;
`;

const Super = styled.span`
  color: red;
  margin-left: 2px;
`;

const CustomDocumentLink = styled.a`
  display: inline-flex;
  align-items: center;
  color: #4945ff;
  text-decoration: none;
  font-size: 13px;
  font-family: var(--font-family-reg);
  margin-top: 5px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const VRSubTitle = styled.div`
  color: #71717a;
  font-size: 13px;
  font-family: var(--font-family-reg);
  margin-bottom: 15px;
`;

const VendorDocumentRequests = ({
  isStepper = false,
  handleBack,
  activeStep,
  setActiveStep,
  isLocked = false,
  isCreation = false,
  vendor_id,
  skipped,
  setSkipped,
  isStepSkipped,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { vendorRequests, loading } = useSelector(
    (state) => state.documentRequests,
  );
  const { createdUser, vendor_details } = useSelector(
    (state) => state.vendorRegistration,
  );

  const [localUploading, setLocalUploading] = useState(false);
  const [isFinishing, setIsFinishing] = useState(false);
  const [localChanges, setLocalChanges] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  // Statutory Documents Local States
  const [statutoryDocs, setStatutoryDocs] = useState({
    panDoc: "",
    dealer: "",
    tin: "",
    iso: "",
    coa: "",
    qualityAudit: "",
    hazardous: "",
    sds: "",
    unCert: "",
    vendorSite: "",
  });
  const [anyDocs, setAnyDocs] = useState([]);
  const [newDocs, setNewDocs] = useState([0]);
  const showRequestedDocs = useFeature("requested_documents");
  const isVendorApproval = useFeature("vendor_approval_workflow");
  const isVendorTerms = useFeature("show_vendor_terms");
  const isTenant2 = useFeature("vendor_approval_workflow");
  const currentVendorId = vendor_id;
  const fetchRequestsList = () => {
    const isOfficerOrAdmin =
      user?.roles?.[0] === ROLES.OFFICER ||
      ADMIN_ROLES.includes(user?.roles?.[0]);
    if (isOfficerOrAdmin && currentVendorId) {
      dispatch(getAdminVendorRequestsThunk(currentVendorId));
    } else {
      dispatch(getVendorRequestsThunk());
    }
  };
  useEffect(() => {
    fetchRequestsList();
    if (currentVendorId) {
      dispatch(getVendorDetails(currentVendorId));
    }
    // eslint-disable-next-line
  }, [currentVendorId]);

  // Load database statutory documents on mount / details update
  useEffect(() => {
    if (
      vendor_details &&
      String(vendor_details?.id) === String(currentVendorId)
    ) {
      const docs = vendor_details.Documents?.[0];
      if (docs) {
        const loadedDocs = {};
        if (docs.pan_image_name) {
          loadedDocs.panDoc = {
            name: docs.pan_image_name,
            url: docs.pan_image,
          };
        }
        if (docs.dealer_authorization_image_name) {
          loadedDocs.dealer = {
            name: docs.dealer_authorization_image_name,
            url: docs.dealer_authorization_image,
          };
        }
        if (docs.tin_certificate_image_name) {
          loadedDocs.tin = {
            name: docs.tin_certificate_image_name,
            url: docs.tin_certificate_image,
          };
        }
        if (docs.iso_or_rsdo_or_any_image_name) {
          loadedDocs.iso = {
            name: docs.iso_or_rsdo_or_any_image_name,
            url: docs.iso_or_rsdo_or_any_image,
          };
        }
        if (docs.coa_test_certificate_image_name) {
          loadedDocs.coa = {
            name: docs.coa_test_certificate_image_name,
            url: docs.coa_test_certificate_image,
          };
        }
        if (docs.quality_audit_report_image_name) {
          loadedDocs.qualityAudit = {
            name: docs.quality_audit_report_image_name,
            url: docs.quality_audit_report_image,
          };
        }
        if (docs.hazardous_material_declaration_image_name) {
          loadedDocs.hazardous = {
            name: docs.hazardous_material_declaration_image_name,
            url: docs.hazardous_material_declaration_image,
          };
        }
        if (docs.sds_msds_availability_image_name) {
          loadedDocs.sds = {
            name: docs.sds_msds_availability_image_name,
            url: docs.sds_msds_availability_image,
          };
        }
        if (docs.un_certificates_image_name) {
          loadedDocs.unCert = {
            name: docs.un_certificates_image_name,
            url: docs.un_certificates_image,
          };
        }
        if (docs.vendor_site_images_name) {
          loadedDocs.vendorSite = {
            name: docs.vendor_site_images_name,
            url: docs.vendor_site_images,
          };
        }
        setStatutoryDocs((prev) => ({
          ...prev,
          ...loadedDocs,
        }));

        if (docs.supporting_document_image_name) {
          const fileName = docs.supporting_document_image_name;
          const filePath = docs.supporting_document_image;
          if (Array.isArray(fileName) && Array.isArray(filePath)) {
            const concatResource = fileName.map(function (fn, idx) {
              return { name: fn, path: filePath[idx] };
            });
            setAnyDocs(concatResource);
            setNewDocs(concatResource.length > 0 ? concatResource : [0]);
          }
        }
      }
    }
  }, [vendor_details, currentVendorId]);

  const user = LocalStorage.getItem(SESSION_KEY);
  const is_domestic =
    vendor_details?.is_domestic !== undefined
      ? vendor_details.is_domestic
      : user?.is_domestic;

  const handleAddAnyDoc = () => {
    setNewDocs([...newDocs, newDocs.length]);
  };

  const handleRemoveAnyDoc = (index) => {
    const tempDocs = [...anyDocs];
    tempDocs.splice(index, 1);
    setAnyDocs(tempDocs);

    const tempNewDocs = [...newDocs];
    tempNewDocs.splice(index, 1);
    setNewDocs(tempNewDocs);
  };

  const handleChangeAnyDoc = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;
    const tempDocs = [...anyDocs];
    tempDocs[index] = file;
    setAnyDocs(tempDocs);
  };

  const handleClearAnyDoc = (index) => {
    const tempDocs = [...anyDocs];
    tempDocs[index] = "";
    setAnyDocs(tempDocs);
  };

  const getDocInfo = (item) => {
    if (localChanges[item.id] !== undefined) {
      return localChanges[item.id];
    }
    if (item.pendingChange) {
      const pUrl = item.pendingChange.new_value;
      let pName = "Uploaded Document";
      if (pUrl) {
        try {
          const parts = pUrl.split("/");
          pName = decodeURIComponent(parts[parts.length - 1]).replace(
            /^\d+-/,
            "",
          );
        } catch (e) {}
      }
      return {
        uploaded_file_url: pUrl || "",
        uploaded_file_name: pName,
      };
    }
    return {
      uploaded_file_url: item.uploaded_file_url,
      uploaded_file_name: item.uploaded_file_name,
    };
  };

  const getFileNameFromUrl = (url) => {
    if (!url) return "";
    try {
      const parts = url.split("/");
      const fileName = decodeURIComponent(parts[parts.length - 1]);
      return fileName.replace(/^\d+-/, "");
    } catch (e) {
      return "Uploaded Document";
    }
  };

  const truncateFileName = (fileName, maxLength = 25) => {
    if (!fileName) return "";
    if (fileName.length <= maxLength) return fileName;
    const dotIndex = fileName.lastIndexOf(".");
    if (dotIndex !== -1 && fileName.length - dotIndex <= 6) {
      const ext = fileName.substring(dotIndex);
      const name = fileName.substring(0, dotIndex);
      const limit = maxLength - ext.length - 3;
      if (limit > 0) {
        return name.substring(0, limit) + "..." + ext;
      }
    }
    return fileName.substring(0, maxLength - 3) + "...";
  };

  const handleFileChange = async (event, mappingId) => {
    const target = event.target;
    const file = target ? target.files[0] : null;
    if (!file) return;

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      message.error("File size exceeds 10MB limit.");
      if (target) target.value = "";
      return;
    }

    setLocalChanges((prev) => ({
      ...prev,
      [mappingId]: {
        file: file,
        uploaded_file_url: URL.createObjectURL(file),
        uploaded_file_name: file.name,
        isNewFile: true,
      },
    }));

    if (target) target.value = "";
  };

  const handleRemoveClick = (mappingId) => {
    setLocalChanges((prev) => ({
      ...prev,
      [mappingId]: {
        file: null,
        uploaded_file_url: "",
        uploaded_file_name: "",
        isRemoved: true,
      },
    }));
  };

  // Submit Statutory Documents Form
  const saveStatutoryDocuments = async () => {
    let hasError = false;
    if (is_domestic && !statutoryDocs.panDoc) {
      message.error("Please upload PAN copy");
      hasError = true;
    }
    if (hasError) return false;

    const formData = new FormData();
    formData.vendor_id = currentVendorId;

    if (statutoryDocs.panDoc instanceof File) {
      formData.append("pan_image", statutoryDocs.panDoc);
    }
    if (statutoryDocs.dealer instanceof File) {
      formData.append("dealer_authorization_image", statutoryDocs.dealer);
    }
    if (statutoryDocs.tin instanceof File) {
      formData.append("tin_certificate_image", statutoryDocs.tin);
    }
    if (statutoryDocs.iso instanceof File) {
      formData.append("iso_or_rsdo_or_any_image", statutoryDocs.iso);
    }
    if (statutoryDocs.coa instanceof File) {
      formData.append("coa_test_certificate_image", statutoryDocs.coa);
    }
    if (statutoryDocs.qualityAudit instanceof File) {
      formData.append("quality_audit_report_image", statutoryDocs.qualityAudit);
    }
    if (statutoryDocs.hazardous instanceof File) {
      formData.append(
        "hazardous_material_declaration_image",
        statutoryDocs.hazardous,
      );
    }
    if (statutoryDocs.sds instanceof File) {
      formData.append("sds_msds_availability_image", statutoryDocs.sds);
    }
    if (statutoryDocs.unCert instanceof File) {
      formData.append("un_certificates_image", statutoryDocs.unCert);
    }
    if (statutoryDocs.vendorSite instanceof File) {
      formData.append("vendor_site_images", statutoryDocs.vendorSite);
    }

    anyDocs.forEach((doc) => {
      if (doc instanceof File) {
        formData.append("supporting_document_image", doc);
      }
    });

    const supportingDocsInfo = anyDocs
      .map((doc) => {
        if (doc && doc.path) {
          return { name: doc.name, path: doc.path };
        } else if (doc instanceof File) {
          return { name: doc.name, isNew: true };
        } else {
          return null;
        }
      })
      .filter(Boolean);
    formData.append("supporting_docs_info", JSON.stringify(supportingDocsInfo));

    try {
      const res = await dispatch(vendorRegistrationUpdateDocuments(formData)).unwrap();
      if (!res || res?.success === false || res?.errorMessage) {
        const errorMsg =
          res?.errorMessage ||
          res?.message ||
          "Failed to update statutory documents";
        message.error({ content: errorMsg, key: "saving" });
        return false;
      }

      return true;
    } catch (err) {
      const errorMsg =
        err?.errorMessage ||
        err?.message ||
        "Failed to update statutory documents";
      message.error({ content: errorMsg, key: "saving" });
      return false;
    }
  };

  const handleSaveAll = async () => {
    setIsSaving(true);
    message.loading({ content: "Saving document changes...", key: "saving" });

    try {
      const statutorySaved = await saveStatutoryDocuments();
      if (!statutorySaved) {
        setIsSaving(false);
        return false;
      }

      const keys = Object.keys(localChanges);
      if (keys.length > 0) {
        for (const mappingId of keys) {
          const change = localChanges[mappingId];
          if (change.isNewFile) {
            const formData = new FormData();
            formData.append("file", change.file);
            formData.append("vendor_document_request_id", Number(mappingId));
            const uploadRes = await dispatch(uploadVendorDocThunk(formData)).unwrap();
            if (!uploadRes || uploadRes.success === false || uploadRes.errorMessage) {
              const errorMsg = uploadRes?.errorMessage || uploadRes?.message || "Failed to upload document";
              message.error({ content: errorMsg, key: "saving" });
              setIsSaving(false);
              return false;
            }
          } else if (change.isRemoved) {
            const removeRes = await dispatch(
              uploadVendorDocThunk({
                vendor_document_request_id: Number(mappingId),
                uploaded_file_url: "",
                uploaded_file_name: "",
              }),
            ).unwrap();
            if (!removeRes || removeRes.success === false || removeRes.errorMessage) {
              const errorMsg = removeRes?.errorMessage || removeRes?.message || "Failed to remove document";
              message.error({ content: errorMsg, key: "saving" });
              setIsSaving(false);
              return false;
            }
          }
        }
        setLocalChanges({});
      }

      setStatutoryDocs({
        panDoc: "",
        dealer: "",
        tin: "",
        iso: "",
        coa: "",
        qualityAudit: "",
        hazardous: "",
        sds: "",
        unCert: "",
        vendorSite: "",
      });
      setAnyDocs([]);
      setNewDocs([0]);

      message.success({ content: "All changes saved successfully!", key: "saving" });
      if (currentVendorId) {
        dispatch(getVendorDetails(currentVendorId));
      }
      fetchRequestsList();
      return true;
    } catch (err) {
      message.error({ content: err?.errorMessage || err?.message || "Failed to save some document changes.", key: "saving" });
      console.error(err);
      return false;
    } finally {
      setIsSaving(false);
    }
  };

  const areRequiredDocsMissing = () => {
    if (!vendorRequests || vendorRequests.length === 0) return false;
    return vendorRequests.some((item) => {
      const isRequired = item.DocumentRequest?.is_required;
      if (!isRequired) return false;
      const currentDoc = getDocInfo(item);
      return !currentDoc.uploaded_file_url || item.status === "REJECTED";
    });
  };

  const handleFinish = async () => {
    setIsFinishing(true);
    if (is_domestic && !statutoryDocs.panDoc) {
      message.error("Please upload PAN copy");
      setIsFinishing(false);
      return;
    }

    const hasStatutoryFiles =
      Boolean(statutoryDocs.panDoc instanceof File) ||
      Boolean(statutoryDocs.dealer instanceof File) ||
      Boolean(statutoryDocs.tin instanceof File) ||
      Boolean(statutoryDocs.iso instanceof File) ||
      Boolean(statutoryDocs.coa instanceof File) ||
      Boolean(statutoryDocs.qualityAudit instanceof File) ||
      Boolean(statutoryDocs.hazardous instanceof File) ||
      Boolean(statutoryDocs.sds instanceof File) ||
      Boolean(statutoryDocs.unCert instanceof File) ||
      Boolean(statutoryDocs.vendorSite instanceof File) ||
      anyDocs.some((d) => d instanceof File);

    if (hasChanges || hasStatutoryFiles) {
      const saveSuccess = await handleSaveAll();
      if (!saveSuccess) {
        setIsFinishing(false);
        return;
      }
    }

    if (isStepper) {
      setIsFinishing(false);
      dispatch(clearVendorDetails());
      setLocalUploading(false);
      setLocalChanges({});
      setIsSaving(false);
      setStatutoryDocs({
        panDoc: "",
        dealer: "",
        tin: "",
        iso: "",
        coa: "",
        qualityAudit: "",
        hazardous: "",
        sds: "",
        unCert: "",
        vendorSite: "",
      });
      setAnyDocs([]);
      setNewDocs([0]);

      let newSkipped = skipped;
      if (isStepSkipped && isStepSkipped(activeStep)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
      }
      if (setActiveStep) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
      if (setSkipped) {
        setSkipped(newSkipped);
      }
      return;
    }

    const primary_role = user.roles[0];
    const payload = {
      vendor_id: currentVendorId,
      is_finish: isCreation ? true : isTenant2 ? true : false,
    };

    dispatch(submitVendorEdit(payload))
      .unwrap()
      .then((res) => {
        setIsFinishing(false);
        if (res?.success) {
          dispatch(clearVendorDetails());
          setLocalUploading(false);
          setLocalChanges({});
          setIsSaving(false);
          setStatutoryDocs({
            panDoc: "",
            dealer: "",
            tin: "",
            iso: "",
            coa: "",
            qualityAudit: "",
            hazardous: "",
            sds: "",
            unCert: "",
            vendorSite: "",
          });
          setAnyDocs([]);
          setNewDocs([0]);
          message.success(
            isCreation
              ? "Registration completed successfully!"
              : res?.message || "Edits submitted successfully.",
          );
        } else {
          message.info(res?.message || "No pending edits to submit.");
        }
        if (isCreation || primary_role === ROLES.USER) {
          if (primary_role === ROLES.OFFICER) {
            navigate("/app/vendor");
          } else {
            navigate("/app");
          }
        } else {
          let newSkipped = skipped;
          if (isStepSkipped && isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
          }
          if (setActiveStep) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
          }
          if (setSkipped) {
            setSkipped(newSkipped);
          }
        }
      })
      .catch((err) => {
        setIsFinishing(false);
        message.error(
          isCreation
            ? "Failed to finalize registration."
            : "Failed to submit edits.",
        );
      });
  };

  const getStatusChip = (status) => {
    switch (status) {
      case "APPROVED":
        return <Chip label="Approved" color="success" size="small" />;
      case "REJECTED":
        return <Chip label="Rejected" color="error" size="small" />;
      case "UPLOADED":
        return <Chip label="Submitted" color="warning" size="small" />;
      default:
        return <Chip label="Pending Action" color="default" size="small" />;
    }
  };

  const statutoryDocsCard = (
    <CardContent>
      <Container fixed>
        <VendorCardTitle style={{ marginBottom: "3px" }}>
          Statutory & Supporting Documents
        </VendorCardTitle>
        <VRSubTitle style={{ display: "flex", alignItems: "center" }}>
          <img
            src={info}
            alt="icon"
            style={{ marginRight: "8px", verticalAlign: "middle" }}
          />
          TDS may be deducted at higher rates in case of incorrect or missing
          PAN information as per IT rules.
        </VRSubTitle>
        <Grid container spacing={2}>
          {/* PAN copy */}
          {is_domestic && (
            <Grid container item spacing={1} alignItems="center" xs={12}>
              <Grid item xs={6}>
                <DocumentLabels style={{ marginTop: "10px" }}>
                  Upload PAN copy <Super>*</Super>
                </DocumentLabels>
              </Grid>
              <Grid item xs={6}>
                {statutoryDocs.panDoc ? (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Chip
                      style={{
                        width: "150px",
                        color: "#4945FF",
                        margin: "5px",
                        borderRadius: "5px",
                        border: "1px solid #D9D8FF",
                        background: "#F0F0FF",
                      }}
                      label={statutoryDocs.panDoc.name}
                      onClick={() =>
                        statutoryDocs.panDoc.url &&
                        window.open(statutoryDocs.panDoc.url, "_blank")
                      }
                      clickable={!!statutoryDocs.panDoc.url}
                    />
                    {!isLocked && (
                      <HighlightOffIcon
                        style={{ color: "#4945FF", cursor: "pointer" }}
                        onClick={() =>
                          setStatutoryDocs((prev) => ({ ...prev, panDoc: "" }))
                        }
                      />
                    )}
                  </Box>
                ) : (
                  <label htmlFor="pan_image_file">
                    <Input
                      accept=".pdf,.jpg,.jpeg,.png"
                      id="pan_image_file"
                      type="file"
                      onChange={(e) =>
                        setStatutoryDocs((prev) => ({
                          ...prev,
                          panDoc: e.target.files[0],
                        }))
                      }
                    />
                    <StyledOutlineButton
                      variant="outlined"
                      component="span"
                      disabled={isLocked}
                    >
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
            </Grid>
          )}

          {/* VAD / Vendor Form copy */}
          <Grid container item spacing={1} alignItems="center" xs={12}>
            <Grid item xs={6}>
              <DocumentLabels style={{ marginTop: "10px" }}>
                {isVendorTerms ? "VAD" : "Vendor information form"}
              </DocumentLabels>
            </Grid>
            <Grid item xs={6}>
              {statutoryDocs.dealer ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <Chip
                    style={{
                      width: "150px",
                      color: "#4945FF",
                      margin: "5px",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={statutoryDocs.dealer.name}
                    onClick={() =>
                      statutoryDocs.dealer.url &&
                      window.open(statutoryDocs.dealer.url, "_blank")
                    }
                    clickable={!!statutoryDocs.dealer.url}
                  />
                  {!isLocked && (
                    <HighlightOffIcon
                      style={{ color: "#4945FF", cursor: "pointer" }}
                      onClick={() =>
                        setStatutoryDocs((prev) => ({ ...prev, dealer: "" }))
                      }
                    />
                  )}
                </Box>
              ) : (
                <label htmlFor="dealer_image_file">
                  <Input
                    accept=".pdf,.jpg,.jpeg,.png,.docx"
                    id="dealer_image_file"
                    type="file"
                    onChange={(e) =>
                      setStatutoryDocs((prev) => ({
                        ...prev,
                        dealer: e.target.files[0],
                      }))
                    }
                  />
                  <StyledOutlineButton
                    variant="outlined"
                    component="span"
                    disabled={isLocked}
                  >
                    Upload
                  </StyledOutlineButton>
                </label>
              )}
            </Grid>
          </Grid>

          {/* TIN Certificate */}
          <Grid container item spacing={1} alignItems="center" xs={12}>
            <Grid item xs={6}>
              <DocumentLabels style={{ marginTop: "10px" }}>
                Upload TIN certificate
              </DocumentLabels>
            </Grid>
            <Grid item xs={6}>
              {statutoryDocs.tin ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <Chip
                    style={{
                      width: "150px",
                      color: "#4945FF",
                      margin: "5px",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={statutoryDocs.tin.name}
                    onClick={() =>
                      statutoryDocs.tin.url &&
                      window.open(statutoryDocs.tin.url, "_blank")
                    }
                    clickable={!!statutoryDocs.tin.url}
                  />
                  {!isLocked && (
                    <HighlightOffIcon
                      style={{ color: "#4945FF", cursor: "pointer" }}
                      onClick={() =>
                        setStatutoryDocs((prev) => ({ ...prev, tin: "" }))
                      }
                    />
                  )}
                </Box>
              ) : (
                <label htmlFor="tin_image_file">
                  <Input
                    accept=".pdf,.jpg,.jpeg,.png"
                    id="tin_image_file"
                    type="file"
                    onChange={(e) =>
                      setStatutoryDocs((prev) => ({
                        ...prev,
                        tin: e.target.files[0],
                      }))
                    }
                  />
                  <StyledOutlineButton
                    variant="outlined"
                    component="span"
                    disabled={isLocked}
                  >
                    Upload
                  </StyledOutlineButton>
                </label>
              )}
            </Grid>
          </Grid>

          {/* ISO Certificate */}
          <Grid container item spacing={1} alignItems="center" xs={12}>
            <Grid item xs={6}>
              <DocumentLabels style={{ marginTop: "10px" }}>
                Upload ISO, RSDO and any additional certificate
              </DocumentLabels>
            </Grid>
            <Grid item xs={6}>
              {statutoryDocs.iso ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <Chip
                    style={{
                      width: "150px",
                      color: "#4945FF",
                      margin: "5px",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={statutoryDocs.iso.name}
                    onClick={() =>
                      statutoryDocs.iso.url &&
                      window.open(statutoryDocs.iso.url, "_blank")
                    }
                    clickable={!!statutoryDocs.iso.url}
                  />
                  {!isLocked && (
                    <HighlightOffIcon
                      style={{ color: "#4945FF", cursor: "pointer" }}
                      onClick={() =>
                        setStatutoryDocs((prev) => ({ ...prev, iso: "" }))
                      }
                    />
                  )}
                </Box>
              ) : (
                <label htmlFor="iso_image_file">
                  <Input
                    accept=".pdf,.jpg,.jpeg,.png"
                    id="iso_image_file"
                    type="file"
                    onChange={(e) =>
                      setStatutoryDocs((prev) => ({
                        ...prev,
                        iso: e.target.files[0],
                      }))
                    }
                  />
                  <StyledOutlineButton
                    variant="outlined"
                    component="span"
                    disabled={isLocked}
                  >
                    Upload
                  </StyledOutlineButton>
                </label>
              )}
            </Grid>
          </Grid>

          {/* COA / Test Certificate */}
          <Grid container item spacing={1} alignItems="center" xs={12}>
            <Grid item xs={6}>
              <DocumentLabels style={{ marginTop: "10px" }}>
                Upload COA / Test Certificate
              </DocumentLabels>
            </Grid>
            <Grid item xs={6}>
              {statutoryDocs.coa ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <Chip
                    style={{
                      width: "150px",
                      color: "#4945FF",
                      margin: "5px",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={statutoryDocs.coa.name}
                    onClick={() =>
                      statutoryDocs.coa.url &&
                      window.open(statutoryDocs.coa.url, "_blank")
                    }
                    clickable={!!statutoryDocs.coa.url}
                  />
                  {!isLocked && (
                    <HighlightOffIcon
                      style={{ color: "#4945FF", cursor: "pointer" }}
                      onClick={() =>
                        setStatutoryDocs((prev) => ({ ...prev, coa: "" }))
                      }
                    />
                  )}
                </Box>
              ) : (
                <label htmlFor="coa_image_file">
                  <Input
                    accept=".pdf,.jpg,.jpeg,.png"
                    id="coa_image_file"
                    type="file"
                    onChange={(e) =>
                      setStatutoryDocs((prev) => ({
                        ...prev,
                        coa: e.target.files[0],
                      }))
                    }
                  />
                  <StyledOutlineButton
                    variant="outlined"
                    component="span"
                    disabled={isLocked}
                  >
                    Upload
                  </StyledOutlineButton>
                </label>
              )}
            </Grid>
          </Grid>

          {/* Quality Audit Report */}
          <Grid container item spacing={1} alignItems="center" xs={12}>
            <Grid item xs={6}>
              <DocumentLabels style={{ marginTop: "10px" }}>
                Upload Quality Audit Report
              </DocumentLabels>
            </Grid>
            <Grid item xs={6}>
              {statutoryDocs.qualityAudit ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <Chip
                    style={{
                      width: "150px",
                      color: "#4945FF",
                      margin: "5px",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={statutoryDocs.qualityAudit.name}
                    onClick={() =>
                      statutoryDocs.qualityAudit.url &&
                      window.open(statutoryDocs.qualityAudit.url, "_blank")
                    }
                    clickable={!!statutoryDocs.qualityAudit.url}
                  />
                  {!isLocked && (
                    <HighlightOffIcon
                      style={{ color: "#4945FF", cursor: "pointer" }}
                      onClick={() =>
                        setStatutoryDocs((prev) => ({
                          ...prev,
                          qualityAudit: "",
                        }))
                      }
                    />
                  )}
                </Box>
              ) : (
                <label htmlFor="qa_image_file">
                  <Input
                    accept=".pdf,.jpg,.jpeg,.png"
                    id="qa_image_file"
                    type="file"
                    onChange={(e) =>
                      setStatutoryDocs((prev) => ({
                        ...prev,
                        qualityAudit: e.target.files[0],
                      }))
                    }
                  />
                  <StyledOutlineButton
                    variant="outlined"
                    component="span"
                    disabled={isLocked}
                  >
                    Upload
                  </StyledOutlineButton>
                </label>
              )}
            </Grid>
          </Grid>

          {/* Hazardous Material Declaration */}
          <Grid container item spacing={1} alignItems="center" xs={12}>
            <Grid item xs={6}>
              <DocumentLabels style={{ marginTop: "10px" }}>
                Upload Hazardous Material Declaration
              </DocumentLabels>
            </Grid>
            <Grid item xs={6}>
              {statutoryDocs.hazardous ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <Chip
                    style={{
                      width: "150px",
                      color: "#4945FF",
                      margin: "5px",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={statutoryDocs.hazardous.name}
                    onClick={() =>
                      statutoryDocs.hazardous.url &&
                      window.open(statutoryDocs.hazardous.url, "_blank")
                    }
                    clickable={!!statutoryDocs.hazardous.url}
                  />
                  {!isLocked && (
                    <HighlightOffIcon
                      style={{ color: "#4945FF", cursor: "pointer" }}
                      onClick={() =>
                        setStatutoryDocs((prev) => ({ ...prev, hazardous: "" }))
                      }
                    />
                  )}
                </Box>
              ) : (
                <label htmlFor="haz_image_file">
                  <Input
                    accept=".pdf,.jpg,.jpeg,.png"
                    id="haz_image_file"
                    type="file"
                    onChange={(e) =>
                      setStatutoryDocs((prev) => ({
                        ...prev,
                        hazardous: e.target.files[0],
                      }))
                    }
                  />
                  <StyledOutlineButton
                    variant="outlined"
                    component="span"
                    disabled={isLocked}
                  >
                    Upload
                  </StyledOutlineButton>
                </label>
              )}
            </Grid>
          </Grid>

          {/* SDS / MSDS Availability */}
          <Grid container item spacing={1} alignItems="center" xs={12}>
            <Grid item xs={6}>
              <DocumentLabels style={{ marginTop: "10px" }}>
                Upload SDS / MSDS Availability
              </DocumentLabels>
            </Grid>
            <Grid item xs={6}>
              {statutoryDocs.sds ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <Chip
                    style={{
                      width: "150px",
                      color: "#4945FF",
                      margin: "5px",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={statutoryDocs.sds.name}
                    onClick={() =>
                      statutoryDocs.sds.url &&
                      window.open(statutoryDocs.sds.url, "_blank")
                    }
                    clickable={!!statutoryDocs.sds.url}
                  />
                  {!isLocked && (
                    <HighlightOffIcon
                      style={{ color: "#4945FF", cursor: "pointer" }}
                      onClick={() =>
                        setStatutoryDocs((prev) => ({ ...prev, sds: "" }))
                      }
                    />
                  )}
                </Box>
              ) : (
                <label htmlFor="sds_image_file">
                  <Input
                    accept=".pdf,.jpg,.jpeg,.png"
                    id="sds_image_file"
                    type="file"
                    onChange={(e) =>
                      setStatutoryDocs((prev) => ({
                        ...prev,
                        sds: e.target.files[0],
                      }))
                    }
                  />
                  <StyledOutlineButton
                    variant="outlined"
                    component="span"
                    disabled={isLocked}
                  >
                    Upload
                  </StyledOutlineButton>
                </label>
              )}
            </Grid>
          </Grid>

          {/* UN Certificates */}
          <Grid container item spacing={1} alignItems="center" xs={12}>
            <Grid item xs={6}>
              <DocumentLabels style={{ marginTop: "10px" }}>
                Upload UN Certificates
              </DocumentLabels>
            </Grid>
            <Grid item xs={6}>
              {statutoryDocs.unCert ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <Chip
                    style={{
                      width: "150px",
                      color: "#4945FF",
                      margin: "5px",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={statutoryDocs.unCert.name}
                    onClick={() =>
                      statutoryDocs.unCert.url &&
                      window.open(statutoryDocs.unCert.url, "_blank")
                    }
                    clickable={!!statutoryDocs.unCert.url}
                  />
                  {!isLocked && (
                    <HighlightOffIcon
                      style={{ color: "#4945FF", cursor: "pointer" }}
                      onClick={() =>
                        setStatutoryDocs((prev) => ({ ...prev, unCert: "" }))
                      }
                    />
                  )}
                </Box>
              ) : (
                <label htmlFor="un_image_file">
                  <Input
                    accept=".pdf,.jpg,.jpeg,.png"
                    id="un_image_file"
                    type="file"
                    onChange={(e) =>
                      setStatutoryDocs((prev) => ({
                        ...prev,
                        unCert: e.target.files[0],
                      }))
                    }
                  />
                  <StyledOutlineButton
                    variant="outlined"
                    component="span"
                    disabled={isLocked}
                  >
                    Upload
                  </StyledOutlineButton>
                </label>
              )}
            </Grid>
          </Grid>

          {/* Site Images */}
          <Grid container item spacing={1} alignItems="center" xs={12}>
            <Grid item xs={6}>
              <DocumentLabels style={{ marginTop: "10px" }}>
                Upload Vendor Site Images
              </DocumentLabels>
            </Grid>
            <Grid item xs={6}>
              {statutoryDocs.vendorSite ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <Chip
                    style={{
                      width: "150px",
                      color: "#4945FF",
                      margin: "5px",
                      borderRadius: "5px",
                      border: "1px solid #D9D8FF",
                      background: "#F0F0FF",
                    }}
                    label={statutoryDocs.vendorSite.name}
                    onClick={() =>
                      statutoryDocs.vendorSite.url &&
                      window.open(statutoryDocs.vendorSite.url, "_blank")
                    }
                    clickable={!!statutoryDocs.vendorSite.url}
                  />
                  {!isLocked && (
                    <HighlightOffIcon
                      style={{ color: "#4945FF", cursor: "pointer" }}
                      onClick={() =>
                        setStatutoryDocs((prev) => ({
                          ...prev,
                          vendorSite: "",
                        }))
                      }
                    />
                  )}
                </Box>
              ) : (
                <label htmlFor="site_image_file">
                  <Input
                    accept=".pdf,.jpg,.jpeg,.png"
                    id="site_image_file"
                    type="file"
                    onChange={(e) =>
                      setStatutoryDocs((prev) => ({
                        ...prev,
                        vendorSite: e.target.files[0],
                      }))
                    }
                  />
                  <StyledOutlineButton
                    variant="outlined"
                    component="span"
                    disabled={isLocked}
                  >
                    Upload
                  </StyledOutlineButton>
                </label>
              )}
            </Grid>
          </Grid>

          {/* Supporting Documents (anyDocs) */}
          {newDocs.map((item, index) => (
            <Grid
              container
              item
              spacing={1}
              alignItems="center"
              xs={12}
              key={index}
            >
              <Grid item xs={6}>
                <DocumentLabels style={{ marginTop: "10px" }}>
                  Upload Any Documents
                </DocumentLabels>
              </Grid>
              <Grid item xs={4}>
                {anyDocs[index] && anyDocs[index] !== "" ? (
                  <Box display="flex" alignItems="center" gap={1}>
                    <Chip
                      style={{
                        width: "150px",
                        color: "#4945FF",
                        margin: "5px",
                        borderRadius: "5px",
                        border: "1px solid #D9D8FF",
                        background: "#F0F0FF",
                      }}
                      label={anyDocs[index].name}
                      onClick={() =>
                        anyDocs[index].path &&
                        window.open(anyDocs[index].path, "_blank")
                      }
                      clickable={!!anyDocs[index].path}
                    />
                    {!isLocked && (
                      <HighlightOffIcon
                        style={{ color: "#4945FF", cursor: "pointer" }}
                        onClick={() => handleClearAnyDoc(index)}
                      />
                    )}
                  </Box>
                ) : (
                  <label htmlFor={`any_doc_file_${index}`}>
                    <Input
                      accept=".pdf,.jpg,.jpeg,.png"
                      id={`any_doc_file_${index}`}
                      type="file"
                      onChange={(e) => handleChangeAnyDoc(e, index)}
                    />
                    <StyledOutlineButton
                      variant="outlined"
                      component="span"
                      disabled={isLocked}
                    >
                      Upload
                    </StyledOutlineButton>
                  </label>
                )}
              </Grid>
              <Grid item xs={2}>
                {index > 0 && !isLocked && (
                  <Button
                    color="error"
                    variant="outlined"
                    size="small"
                    onClick={() => handleRemoveAnyDoc(index)}
                  >
                    Remove
                  </Button>
                )}
              </Grid>
            </Grid>
          ))}

          {!isLocked && (
            <Grid
              container
              item
              xs={12}
              justifyContent="flex-end"
              style={{ marginTop: "10px" }}
            >
              <Button
                size="small"
                color="primary"
                variant="outlined"
                onClick={handleAddAnyDoc}
              >
                Add Document
              </Button>
            </Grid>
          )}
        </Grid>
      </Container>
    </CardContent>
  );

  const content = (
    <>
      {loading && vendorRequests.length === 0 ? (
        <div
          style={{ display: "flex", justifyContent: "center", padding: "2rem" }}
        >
          <CircularProgress />
        </div>
      ) : (
        <CustomTableContainer component={Card}>
          <Table aria-label="simple table">
            <CustomTableHead>
              <TableRow>
                <TableCell>
                  <TableHeaderFont>Sr. No.</TableHeaderFont>
                </TableCell>
                <TableCell>
                  <TableHeaderFont>Document Name</TableHeaderFont>
                </TableCell>
                <TableCell>
                  <TableHeaderFont>Description / Instructions</TableHeaderFont>
                </TableCell>
                <TableCell>
                  <TableHeaderFont>Due Date</TableHeaderFont>
                </TableCell>
                <TableCell>
                  <TableHeaderFont>Required</TableHeaderFont>
                </TableCell>
                <TableCell>
                  <TableHeaderFont>Submitted File</TableHeaderFont>
                </TableCell>
                <TableCell align="center">
                  <TableHeaderFont>Action</TableHeaderFont>
                </TableCell>
              </TableRow>
            </CustomTableHead>

            <TableBody>
              {vendorRequests && vendorRequests.length > 0 ? (
                vendorRequests.map((item, index) => {
                  const currentDoc = getDocInfo(item);
                  return (
                    <TableRow
                      key={item.id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell style={{ fontWeight: 500 }}>
                        {item.DocumentRequest
                          ? item.DocumentRequest.document_name
                          : "-"}
                      </TableCell>
                      <TableCell
                        style={{ maxWidth: "250px", wordBreak: "break-word" }}
                      >
                        {item.DocumentRequest
                          ? item.DocumentRequest.description ||
                            "No description instructions."
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {item.DocumentRequest && item.DocumentRequest.due_date
                          ? moment(item.DocumentRequest.due_date).format(
                              "DD MMM YYYY",
                            )
                          : "No Limit"}
                      </TableCell>
                      <TableCell>
                        {item.DocumentRequest &&
                        item.DocumentRequest.is_required
                          ? "Yes"
                          : "No"}
                      </TableCell>
                      <TableCell>
                        {currentDoc.uploaded_file_url ? (
                          <Tooltip
                            title={
                              currentDoc.uploaded_file_name ||
                              getFileNameFromUrl(currentDoc.uploaded_file_url)
                            }
                          >
                            <a
                              href={currentDoc.uploaded_file_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#1976d2",
                                textDecoration: "underline",
                              }}
                            >
                              {truncateFileName(
                                currentDoc.uploaded_file_name ||
                                  getFileNameFromUrl(
                                    currentDoc.uploaded_file_url,
                                  ),
                              )}
                            </a>
                          </Tooltip>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {isLocked ? (
                          <span style={{ color: "#888", fontSize: "0.85rem" }}>
                            {item.status === "APPROVED"
                              ? "Completed"
                              : "Under Review"}
                          </span>
                        ) : currentDoc.uploaded_file_url ? (
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                          >
                            <HighlightOffIcon
                              sx={{ color: "#4945FF", cursor: "pointer" }}
                              fontSize="medium"
                              onClick={() => handleRemoveClick(item.id)}
                            />
                            <span
                              style={{
                                marginLeft: "4px",
                                fontSize: "0.85rem",
                                color: "#4945FF",
                                cursor: "pointer",
                              }}
                              onClick={() => handleRemoveClick(item.id)}
                            >
                              Remove
                            </span>
                          </span>
                        ) : (
                          <label htmlFor={`requested_doc_${item.id}`}>
                            <input
                              type="file"
                              id={`requested_doc_${item.id}`}
                              name={`requested_doc_${item.id}`}
                              style={{ display: "none" }}
                              accept=".pdf,.jpg,.jpeg,.png,.docx,.xlsx"
                              onChange={(e) => handleFileChange(e, item.id)}
                              disabled={localUploading}
                            />
                            <StyledOutlineButton
                              variant="outlined"
                              component="span"
                              disabled={localUploading}
                              style={{ textTransform: "capitalize" }}
                            >
                              {item.status === "REJECTED"
                                ? "Re-upload"
                                : "Upload"}
                            </StyledOutlineButton>
                          </label>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={7}
                    align="center"
                    style={{ padding: "2rem" }}
                  >
                    No document requests found. You're all caught up!
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CustomTableContainer>
      )}
    </>
  );

  const hasStatutoryChanges =
    statutoryDocs.panDoc instanceof File ||
    statutoryDocs.dealer instanceof File ||
    statutoryDocs.tin instanceof File ||
    statutoryDocs.iso instanceof File ||
    statutoryDocs.coa instanceof File ||
    statutoryDocs.qualityAudit instanceof File ||
    statutoryDocs.hazardous instanceof File ||
    statutoryDocs.sds instanceof File ||
    statutoryDocs.unCert instanceof File ||
    statutoryDocs.vendorSite instanceof File ||
    anyDocs.some((doc) => doc instanceof File) ||
    anyDocs.length !==
      (vendor_details?.Documents?.[0]?.supporting_document_image_name?.length ||
        0);

  const hasChanges =
    Object.keys(localChanges).length > 0 || hasStatutoryChanges;

  if (isStepper) {
    return (
      <Box>
        <StyledCard style={{ marginBottom: "20px" }}>
          {statutoryDocsCard}
        </StyledCard>

        {showRequestedDocs && (
          <StyledCard>
            <CardContent>
              <VendorCardTitle style={{ marginBottom: "15px" }}>
                Requested Documents
              </VendorCardTitle>
              {content}
            </CardContent>
          </StyledCard>
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            pt: 2,
            justifyContent: "space-between",
          }}
        >
          <Button color="inherit" onClick={handleBack} sx={{ mr: 1 }}>
            Back
          </Button>
          <div style={{ display: "flex", gap: "10px" }}>
            {hasChanges && !isStepper && (
              <LoadingButton
                sx={{ textTransform: "none", width: "150px" }}
                color="primary"
                variant="contained"
                onClick={handleSaveAll}
                loading={isSaving}
              >
                Save Changes
              </LoadingButton>
            )}
            <Tooltip
              title={
                !isStepper && hasChanges
                  ? "Please save your changes first"
                  : areRequiredDocsMissing()
                  ? "Please upload all required documents"
                  : ""
              }
              arrow
              placement="top"
            >
              <span>
                <LoadingButton
                  sx={{
                    textTransform: "none",
                    background: "var(--button-color)",
                    width: "200px",
                  }}
                  color="success"
                  variant="contained"
                  onClick={handleFinish}
                  disabled={
                    isLocked ||
                    (!isStepper && hasChanges) ||
                    (showRequestedDocs && areRequiredDocsMissing())
                  }
                  loading={isFinishing}
                >
                  {isStepper ? "Save & Next" : isLocked ? "Submitted" : "Finish"}
                </LoadingButton>
              </span>
            </Tooltip>
          </div>
        </Box>
      </Box>
    );
  }

  return (
    <div>
      <TitleHolder style={{ paddingBottom: "0" }}>
        Documents & Uploads
      </TitleHolder>
      <br />
      <StepperContentHolder>
        <StyledCard style={{ marginBottom: "20px" }}>
          {statutoryDocsCard}
        </StyledCard>

        {showRequestedDocs && (
          <StyledCard>
            <CardContent>
              <VendorCardTitle style={{ marginBottom: "15px" }}>
                Requested Documents
              </VendorCardTitle>
              {content}
            </CardContent>
          </StyledCard>
        )}

        {hasChanges && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <LoadingButton
              sx={{
                textTransform: "none",
                background: "var(--button-color)",
                width: "200px",
              }}
              color="primary"
              variant="contained"
              onClick={handleSaveAll}
              loading={isSaving}
            >
              Save Changes
            </LoadingButton>
          </Box>
        )}
      </StepperContentHolder>
    </div>
  );
};

export default VendorDocumentRequests;
